import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import Dropdown from '../views/dropdown';
import { ICalendarState, RawActions, CalendarActions } from "@adage/ace-calendar";
import { IWACEvent, InputOption, ICalendarReduxState } from "../classes";
import * as _ from "lodash";
import { addImagesToLoad } from '../redux/actions/index';

declare var numberOfMonths: number;
numberOfMonths = numberOfMonths ? numberOfMonths : 1;

interface MonthDropdownExternalProps {
}

interface StateToProps {
    currentMoment: moment.Moment;
    isGrid: boolean;
    updating: boolean;
    rects: { [month: string]: HTMLElement };
}

interface DispatchToProps {
    goToMonth: (month: moment.Moment) => any;
    addImagesToLoad: (dateStrings: Array<string>) => any;
}

type MonthDropdownProps = MonthDropdownExternalProps & StateToProps & DispatchToProps;

interface MonthDropdownState {
    dropdownOptions: Array<InputOption>;
    navHeight: number;
}

class MonthDropdown extends React.Component<MonthDropdownProps, MonthDropdownState> {
    constructor(props: MonthDropdownProps) {
        super(props);

        // Generate the month dropdown internally in the component since it won't change.
        let allMonths: Array<moment.Moment> = [];

        for (let i = 0; i < numberOfMonths; ++i) {
            allMonths.push(moment().clone().add(i, "months"));
        }

        this.state = {
            dropdownOptions: this.dropdownOptions(allMonths),
            navHeight: 0
        };


        this.props.addImagesToLoad([moment().format("MMMM-YYYY")]);
    }

    componentDidMount() {
        this.setState({
            navHeight: document.getElementsByClassName("cal-nav")[0].clientHeight
        });


        window.addEventListener("scroll", this.onBoundScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onBoundScroll);
    }

    private onBoundScroll = _.throttle(this.onScroll.bind(this), 500);

    private onScroll() {
        if (this.props.rects && Object.keys(this.props.rects).length > 0) {
            let closest: HTMLElement = this.props.rects[moment().format("MMMM-YYYY")];
            let visibleMonthElements: Array<HTMLElement> = [];
            const pageOffset = window.pageYOffset;
            const windowBottom = window.pageYOffset + window.innerHeight;

            Object.keys(this.props.rects).forEach(key => {
                const elementOffset = this.props.rects[key].offsetTop;
                if (pageOffset > elementOffset - this.state.navHeight) {
                    closest = this.props.rects[key];
                } else if (windowBottom > elementOffset) {
                    visibleMonthElements.push(this.props.rects[key]);
                }
            });

            const currentMonth = moment(closest.id, "MMM-YYYY").startOf("month");
            const visibleMonths = visibleMonthElements.map(monthElement => moment(monthElement.id, "MMM-YYYY").format("MMMM-YYYY"));

            this.props.goToMonth(currentMonth);

            if (!this.props.isGrid) {
                this.props.addImagesToLoad([currentMonth.format("MMMM-YYYY")].concat(visibleMonths));
            }
        }
    }

    /**
     * This is the format used in moment to populate the VALUE of the dropdown.
     */
    private get dropdownValueFormat(): string {
        return "MMMM-YYYY";
    }

    /**
     * Pass in a moment object and get the VALUE for dropdowns.
     * @param date
     */
    dropdownValue(date: moment.Moment): string {
        return date.format(this.dropdownValueFormat);
    }

    /**
     * Pass in a moment object and get the TEXT for dropdowns.
     * @param date
     */
    dropdownText(date: moment.Moment): string {
        return date.format("MMMM YYYY");
    }

    private scrollToMonth(monthString: string) {
        const interval = setInterval(() => {
            window.requestAnimationFrame(() => {
                let elementId = `${monthString}-list-js`;

                if (this.props.isGrid) {
                    elementId = `${monthString}-grid-js`;
                }

                const monthElement = document.getElementById(elementId);

                if (monthElement && !this.props.updating) {
                    monthElement.scrollIntoView();

                    const imagesInMonth = (CalendarActions.calendarState() as any).lazyLoaderModel.imageHasLoaded[monthString]

                    // Only quit the interval once all images have loaded.
                    if (this.props.isGrid || !imagesInMonth || imagesInMonth.length === 0 || _.every(imagesInMonth, result => result)) {
                        clearInterval(interval);
                    }
                }
            });
        });
    }

    onChange(newValue: string) {
        this.props.goToMonth(moment(newValue, this.dropdownValueFormat));

        this.scrollToMonth(newValue);
    }

    dropdownOptions(items: Array<moment.Moment>): Array<InputOption> {
        return items.map(monthMoment => {
            return {
                value: this.dropdownValue(monthMoment),
                text: this.dropdownText(monthMoment)
            };
        });
    }

    render() {
        return <Dropdown selected={this.dropdownValue(this.props.currentMoment)} onChange={this.onChange.bind(this)} name="Month" options={this.state.dropdownOptions} />
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: MonthDropdownExternalProps): StateToProps {
    return {
        currentMoment: state.calendarModel.currentDate,
        isGrid: state.calendarModeModel.isGrid,
        updating: state.calendarModel.updating,
        rects: state.lazyLoaderModel.elements
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>): DispatchToProps {
    return {
        goToMonth: (month: moment.Moment) => dispatch(RawActions.goToMonth(month)),
        addImagesToLoad: (dateStrings: Array<string>) => dispatch(addImagesToLoad(dateStrings))
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(MonthDropdown);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/month-dropdown.tsx